import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useSaveTataIntegration, useTataIntegration } from "../../lib/api";
import { PrimaryButton, Toggle, inputClass } from "./primitives";

// Where the Pre-IFR events go: the webhook address and token and the on/off switch. What was sent, and
// sending a failed event again, is in System health, Pre-IFR Agent.
export default function TataIntegration({ tenantId }) {
  const { data } = useTataIntegration(tenantId);
  const save = useSaveTataIntegration(tenantId);
  const [url, setUrl] = useState("");
  const [token, setToken] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!data) return;
    setUrl(data.endpoint_url || "");
    setEnabled(!!data.enabled);
    setToken("");
  }, [data?.endpoint_url, data?.enabled, data?.has_token]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return null;

  const changed = url.trim() !== (data.endpoint_url || "") || token !== "" || enabled !== !!data.enabled;
  const problem = enabled && !url.trim() ? "Enter the webhook URL before switching this on." : enabled && !token.trim() && !data.has_token ? "Enter the token before switching this on." : "";

  const onSave = async () => {
    try {
      await save.mutateAsync({ endpoint_url: url.trim(), enabled, ...(token !== "" ? { token } : {}) });
      toast.success("Saved.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save.");
    }
  };

  return (
    <div data-testid="tata-integration" className="mb-6 border-b border-[#F2F4F7] pb-6">
      <div className="flex items-center gap-3">
        <div className="text-[14px] font-semibold text-[#101828]">Webhook</div>
        <Toggle checked={enabled} onChange={setEnabled} label="Webhook active" />
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <input
          className={`${inputClass} w-[420px] max-w-full`}
          value={url}
          placeholder="https://…/api/st/notification-service/v1/chat360/webhook"
          onChange={(e) => setUrl(e.target.value)}
          aria-label="Webhook URL"
        />
        <input
          type="password"
          autoComplete="off"
          className={`${inputClass} w-[240px]`}
          value={token}
          placeholder={data.has_token ? "Token saved (type to replace)" : "Token"}
          onChange={(e) => setToken(e.target.value)}
          aria-label="Webhook token"
        />
        <PrimaryButton onClick={onSave} disabled={save.isPending || !changed || !!problem}>
          Save
        </PrimaryButton>
      </div>
      {problem && changed && (
        <p data-testid="tata-problem" className="mt-3 text-[13px] text-[#B42318]">
          {problem}
        </p>
      )}
      {!data.encryption_ready && (
        <p data-testid="tata-no-key" className="mt-3 text-[13px] text-[#B54708]">
          The server has no BRAND_SECRET_KEY, so a token cannot be stored yet.
        </p>
      )}
    </div>
  );
}
